var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row g-1"},[_c('v-chip',{attrs:{"small":"","color":"secondary"}},[_vm._v(" "+_vm._s(`${_vm.$t('status')}: ${_vm.$t(_vm.status)}`)+" ")]),_c('v-chip',{attrs:{"small":"","color":"info"}},[_vm._v(" "+_vm._s(`${_vm.$t('date')}: ${_vm.date}`)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }